export enum AppRoute {
  FORM_PAGE = '/:programId/:pageId?',
  CONFIRMATION = '/:programId/confirmation',
  SUBMISSION_ERROR = '/:programId/submission-error',
  NOT_FOUND = '*',
}
